var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExeedmelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5276 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8ee323;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.2,500C41.4,500,0,462.3,0,386.3s1.5-31,4.4-48.7L43.6,113C56.1,39.9,95.3,0,180.9,0h422.5c70.9,0,99.7,27.3,99.7,79s-1.5,21.4-3.7,34l-11.8,70.2c-12.6,73.1-51,113-135.9,113H128.5l-5.2,29.5c-2.2,12.6-3,22.2-3,30.3,0,34.7,18.5,36.9,53.2,36.9h464.6l-19.2,107.1H129.2ZM579.8,140.3c1.5-6.6,1.5-12.6,1.5-17.7,0-22.2-11.8-25.8-36.9-25.8H206.1c-31,0-45.1,14.8-50.2,43.6l-12.6,71.6h381.1c31.8,0,45-16.2,50.2-44.3l5.2-27.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x_dir"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.4,359.6l140.4,140.4h-149c-13.3,0-26-5.3-35.4-14.6l-90.4-90.4c-19.5-19.5-19.5-51.2,0-70.7L1362.6,14.6C1372,5.3,1384.7,0,1398,0h149l-359.6,359.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x_esq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1152,175.8l-309.6,309.6c-9.4,9.4-22.1,14.6-35.4,14.6h-149l359.6-359.6L877.3,0h149c13.3,0,26,5.3,35.4,14.6l90.4,90.4c19.5,19.5,19.5,51.2,0,70.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e-2",
    "data-name": "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1631.3,500c-87.9,0-129.2-37.7-129.2-113.7s1.5-31,4.4-48.7l39.1-224.5C1558.2,39.9,1597.3,0,1683,0h422.5c70.9,0,99.7,27.3,99.7,79s-1.5,21.4-3.7,34l-11.8,70.2c-12.6,73.1-51,113-135.9,113h-423.2l-5.2,29.5c-2.2,12.6-3,22.2-3,30.3,0,34.7,18.5,36.9,53.2,36.9h464.6l-19.2,107.1h-489.7ZM2081.8,140.3c1.5-6.6,1.5-12.6,1.5-17.7,0-22.2-11.8-25.8-36.9-25.8h-338.3c-31,0-45.1,14.8-50.2,43.6l-12.6,71.6h381.1c31.8,0,45-16.2,50.2-44.3l5.2-27.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e-3",
    "data-name": "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2357.3,500c-87.9,0-129.2-37.7-129.2-113.7s1.5-31,4.4-48.7l39.1-224.5c12.6-73.1,51.7-113,137.4-113h422.5c70.9,0,99.7,27.3,99.7,79s-1.5,21.4-3.7,34l-11.8,70.2c-12.6,73.1-51,113-135.9,113h-423.2l-5.2,29.5c-2.2,12.6-3,22.2-3,30.3,0,34.7,18.5,36.9,53.2,36.9h464.6l-19.2,107.1h-489.7ZM2807.8,140.3c1.5-6.6,1.5-12.6,1.5-17.7,0-22.2-11.8-25.8-36.9-25.8h-338.3c-31,0-45.1,14.8-50.2,43.6l-12.6,71.6h381.1c31.8,0,45-16.2,50.2-44.3l5.2-27.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2935.5,500L3023.4,0h488.9c93.8,0,140.3,48.7,140.3,130s-1.5,29.5-4.4,45.8l-26.6,151.4c-18.5,106.4-85.7,172.8-197.2,172.8h-488.9ZM3528.6,199.4c3.7-19.9,5.2-35.4,5.2-48,0-39.9-19.2-45.1-62.8-45.1h-350.1l-50.2,286.6h332.4c60.6,0,95.3-22.2,104.9-75.3l20.7-118.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4362.4,500l57.6-325.7c2.2-11.1,3-20.7,3-28.8,0-34.7-19.2-39.1-52.4-39.1h-172.8l-69.4,393.6h-115.2l69.4-393.6h-233.4l-69.4,393.6h-116L3751.6,0h661.7c87.9,0,129.2,39.1,129.2,115.2s-1.5,30.3-4.4,47.3l-59.8,337.5h-116Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e-4",
    "data-name": "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4702.2,500c-87.9,0-129.2-37.7-129.2-113.7s1.5-31,4.4-48.7l39.1-224.5c12.6-73.1,51.7-113,137.4-113h422.5c70.9,0,99.7,27.3,99.7,79s-1.5,21.4-3.7,34l-11.8,70.2c-12.6,73.1-51,113-135.9,113h-423.2l-5.2,29.5c-2.2,12.6-3,22.2-3,30.3,0,34.7,18.5,36.9,53.2,36.9h464.6l-19.2,107.1h-489.7ZM5152.7,140.3c1.5-6.6,1.5-12.6,1.5-17.7,0-22.2-11.8-25.8-36.9-25.8h-338.3c-31,0-45.1,14.8-50.2,43.6l-12.6,71.6h381.1c31.8,0,45-16.2,50.2-44.3l5.2-27.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExeedmelogo);
export default __webpack_public_path__ + "static/media/exeedmelogo.f11a82c3497db4506ea70dfc5ed3e48e.svg";
export { ForwardRef as ReactComponent };